import { render, staticRenderFns } from "./form_block.vue?vue&type=template&id=929b2484&"
import script from "./form_block.vue?vue&type=script&lang=js&"
export * from "./form_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports